module.exports = __webpack_public_path__ + "static/media/1424.6b0aebff.jpg";